import React from 'react';

const Report = ({ history }) => {
  history.push('/report/projects');
  return <></>;
};

export default Report;
